/*
  Maison Etherique — product recommendations
  Same lazy section-render contract as Zest's <product-recommendations>, plus a
  confirmation state on the quick-add button so a tap on mobile gives feedback
  even when the cart drawer is configured to stay closed.
*/
if (!customElements.get("me-product-recommendations")) {
  customElements.define(
    "me-product-recommendations",
    class MEProductRecommendations extends HTMLElement {
      connectedCallback() {
        this.observer = new IntersectionObserver(
          (entries, observer) => {
            if (!entries[0].isIntersecting) return;
            observer.unobserve(this);
            this.load();
          },
          { rootMargin: "0px 0px 400px 0px" }
        );

        this.observer.observe(this);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      load() {
        const url = this.dataset.url;
        if (!url) return;

        fetch(url)
          .then((response) => response.text())
          .then((text) => {
            const html =
              typeof generateDomFromString === "function"
                ? generateDomFromString(text)
                : new DOMParser().parseFromString(text, "text/html");

            const recommendations = html.querySelector(
              "me-product-recommendations"
            );

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
              if (typeof __reInitTooltip === "function") __reInitTooltip(this);
              this.classList.add("me-product-recommendations--loaded");
            } else {
              this.closest(".me-product-recommendations-section")?.setAttribute(
                "hidden",
                ""
              );
            }

            document.dispatchEvent(new CustomEvent("recommendations:loaded"));
          })
          .catch((e) => {
            console.error(e);
          });
      }
    }
  );
}

/*
  Quick-add confirmation. product-form.js owns the request; we only mirror its
  outcome onto whichever button started it.
*/
if (!window.__meQuickAddFeedback) {
  window.__meQuickAddFeedback = true;

  const ADDED_STATE_DURATION = 1600;
  let pendingButton = null;
  let resetTimer = null;

  document.addEventListener(
    "click",
    (event) => {
      const button = event.target.closest("[data-me-quick-add]");
      if (!button || button.disabled) return;
      pendingButton = button;
    },
    true
  );

  const settle = (className) => {
    const button = pendingButton;
    pendingButton = null;
    if (!button || !button.isConnected) return;
    if (!className) return;

    clearTimeout(resetTimer);
    button.classList.add(className);
    resetTimer = setTimeout(() => {
      button.classList.remove(className);
    }, ADDED_STATE_DURATION);
  };

  document.addEventListener("product-ajax:added", () => settle("is-added"));
  document.addEventListener("product-ajax:error", () => settle(null));
}
